<div class="pages-sider" [ngClass]="{'side-collapsed':!sidebarToggle}">
  <span class="sidebar-top-line"></span>
  <du-menu [menuInfo]="menuInfo"></du-menu>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/layouts/sidebar/sidebar.component.html